import { Stack, InputLabel, OutlinedInput, Button } from "@mui/material";
import { produce } from "immer";
import React from "react";
import FormSection from "../../../../../Components/Forms/FormSection/form-section";
import { ExternalLinks } from "../../../../../Core/Api/Types/external-links";
import { SectionGlobalProps } from "../settings-global";
import { useTranslation } from "react-i18next";

const SettingsGlobalSectionExternalLinks: React.FC<SectionGlobalProps> = (props) => {
  const { t } = useTranslation();
  const { platformInfos, setPlatformInfos } = props;
  const [newExternalLink, setNewExternalLink] = React.useState<ExternalLinks>(new ExternalLinks());

  const onClickAdd = () => {
    if (newExternalLink.name && newExternalLink.link) {
      setPlatformInfos(
        produce((draft) => {
          draft.externalLinks?.push(newExternalLink);
        })
      );

      setNewExternalLink(new ExternalLinks());
    }
  };
  const onClickRemove = (indexToRemove: number) => {
    setPlatformInfos(
      produce((draft) => {
        draft.externalLinks = draft.externalLinks!.filter((x, index) => index !== indexToRemove);
      })
    );
  };

  return (
    <FormSection title={t("form:section.title.externalLinks")} status="todo" sx={{ mb: 2 }}>
      <Stack direction="row" spacing={3}>
        <Stack>
          <InputLabel sx={{ mb: 1 }}>{t("common:name")}</InputLabel>
          <OutlinedInput
            value={newExternalLink.name || ""}
            id={"name"}
            sx={{ mb: 2 }}
            onChange={(e) =>
              setNewExternalLink(
                produce((draft) => {
                  draft!.name = e.target.value;
                })
              )
            }
          />
        </Stack>
        <Stack>
          <InputLabel sx={{ mb: 1 }}>{t("common:link")}</InputLabel>
          <OutlinedInput
            value={newExternalLink.link || ""}
            id={"link"}
            sx={{ mb: 2 }}
            onChange={(e) =>
              setNewExternalLink(
                produce((draft) => {
                  draft!.link = e.target.value;
                })
              )
            }
          />
        </Stack>
        <Stack>
          <InputLabel sx={{ mb: 1 }}>{t("common:button")}</InputLabel>
          <Button onClick={onClickAdd} variant="contained">
            {t("common:add")}
          </Button>
        </Stack>
      </Stack>
      {platformInfos.externalLinks?.map((link, index) => (
        <Stack direction="row" spacing={3} key={index}>
          <Stack>
            <OutlinedInput
              value={link.name || ""}
              sx={{ mb: 2 }}
              onChange={(e) =>
                setPlatformInfos(
                  produce((draft) => {
                    draft!.externalLinks![index].name = e.target.value;
                  })
                )
              }
            />
          </Stack>
          <Stack>
            <OutlinedInput
              value={link.link || ""}
              sx={{ mb: 2 }}
              onChange={(e) =>
                setPlatformInfos(
                  produce((draft) => {
                    draft!.externalLinks![index].link = e.target.value;
                  })
                )
              }
            />
          </Stack>
          <Stack>
            <Button onClick={() => onClickRemove(index)} variant="contained">
              {t("common:remove")}
            </Button>
          </Stack>
        </Stack>
      ))}
    </FormSection>
  );
};

export default SettingsGlobalSectionExternalLinks;
